import { authFormPost, authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

const mediaDomain = process.env.REACT_APP_MEDIA_DOMAIN;

export function postAgent16(params) {
  return authPost(`${baseUrl}/Agent16.ashx`, params);
}

export function createPost(params) {
  return authFormPost(
    `${window.location.protocol}//${mediaDomain}/api/createPost.php`,
    params
  );
}

export function createComment(params) {
  return authFormPost(
    `${window.location.protocol}//${mediaDomain}/api/createComment.php`,
    params
  );
}
